import LightGallery from 'lightgallery/react';
import React, { useState, useEffect } from 'react';
import { Text} from 'theme-ui';

export default function Gallery(props) {
    const rawImages = props.images
    const [images, setImages] = useState();

    useEffect(() => {
        let imagesTags = []
        for (let i = 0; i < rawImages.length; i++) {
            imagesTags.push(
                <a key={i} href={rawImages[i].originalSource.source} style={{ marginTop: 1 + 'px', marginRight: 10 + 'px', overflow: 'hidden', display: 'inline-block' }}>
                    <img src={rawImages[i].thumbnailSource.source} />
                </a>
            )
        }
        setImages(imagesTags)
    }, [])

    const onInit = () => {

    };

    return (
        <>
            <Text
                as="p"
                sx={{
                    variant: 'sectionHeader.subTitle',
                    color: 'heading',
                    opacity: 1,
                }}
            >
                Images
            </Text>
            <div style={{ lineHeight: 2 + 'px', textAlign: "center" }}>
                <LightGallery
                    licenseKey='513A96E2-744F44B0-810C09A0-AE2A1F4D'
                    onInit={onInit}
                    plugins={[]}>
                    {images}
                </LightGallery>
            </div>
        </>
    );
}
